var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _path2, _rect6, _path3, _g3, _path4, _path5, _path6, _circle, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 208,
    viewBox: "0 0 258 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.409 200C174.637 200 219.409 155.228 219.409 100C219.409 44.7715 174.637 0 119.409 0C64.1802 0 19.4087 44.7715 19.4087 100C19.4087 155.228 64.1802 200 119.409 200Z",
    fill: "#FFEBF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_146_2534)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5754,
    y: 28.7974,
    width: 103.781,
    height: 129.191,
    rx: 16,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.7421,
    y: 45.4639,
    width: 50,
    height: 5.76667,
    rx: 2.88333,
    fill: "#000094"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7421,
    y: 69.2305,
    width: 83.3333,
    height: 5.76667,
    rx: 2.88333,
    fill: "#D2D6DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7421,
    y: 92.9971,
    width: 83.3333,
    height: 5.76667,
    rx: 2.88333,
    fill: "#D2D6DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7421,
    y: 116.764,
    width: 83.3333,
    height: 5.76667,
    rx: 2.88333,
    fill: "#D2D6DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7421,
    y: 140.531,
    width: 83.3333,
    height: 5.76667,
    rx: 2.88333,
    fill: "#D2D6DB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_146_2534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.534 14.52H184.466C182.133 14.52 180.242 16.5104 180.242 18.9658V43.7317C180.242 46.187 182.133 48.1774 184.466 48.1774H234.534C236.867 48.1774 238.758 46.187 238.758 43.7317V18.9658C238.758 16.5104 236.867 14.52 234.534 14.52Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.742 36.6665C195.504 36.6665 197.742 34.4279 197.742 31.6665C197.742 28.9051 195.504 26.6665 192.742 26.6665C189.981 26.6665 187.742 28.9051 187.742 31.6665C187.742 34.4279 189.981 36.6665 192.742 36.6665Z",
    fill: "#CCC6D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.409,
    y: 26.6665,
    width: 26.6667,
    height: 10,
    rx: 5,
    fill: "#D2D6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.667 163.803C159.4 163.803 169.375 160.556 177.663 154.991L211.579 187.367L223.879 173.096L191.152 141.855C197.196 133.349 200.75 122.949 200.75 111.72C200.75 82.9547 177.432 59.6362 148.667 59.6362C119.902 59.6362 96.5833 82.9547 96.5833 111.72C96.5833 140.484 119.902 163.803 148.667 163.803ZM193.091 111.72C193.091 136.072 173.349 155.814 148.996 155.814C124.644 155.814 104.902 136.072 104.902 111.72C104.902 87.367 124.644 67.6253 148.996 67.6253C173.349 67.6253 193.091 87.367 193.091 111.72Z",
    fill: "#CCC6D9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_146_2534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.992 156.667C174.075 156.667 194.409 136.519 194.409 111.667C194.409 86.8137 174.075 66.6665 148.992 66.6665C123.909 66.6665 103.575 86.8137 103.575 111.667C103.575 136.519 123.909 156.667 148.992 156.667Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.845 111.667L167.836 100.719C168.865 99.6355 169.429 98.196 169.408 96.7061C169.387 95.2161 168.782 93.7931 167.722 92.7394C166.662 91.6858 165.23 91.0845 163.731 91.0634C162.232 91.0423 160.784 91.603 159.694 92.6264L148.678 103.575L137.688 92.6264C137.159 92.0701 136.523 91.6248 135.818 91.317C135.113 91.0091 134.353 90.8449 133.583 90.8341C132.813 90.8232 132.049 90.966 131.335 91.2539C130.622 91.5417 129.973 91.9689 129.429 92.5101C128.884 93.0513 128.455 93.6956 128.165 94.4047C127.875 95.1139 127.732 95.8736 127.743 96.6389C127.754 97.4042 127.919 98.1596 128.228 98.8603C128.538 99.561 128.986 100.193 129.546 100.719L140.555 111.667L129.546 122.615C128.986 123.141 128.538 123.773 128.228 124.473C127.919 125.174 127.754 125.929 127.743 126.695C127.732 127.46 127.875 128.22 128.165 128.929C128.455 129.638 128.884 130.282 129.429 130.824C129.973 131.365 130.622 131.792 131.335 132.08C132.049 132.368 132.813 132.51 133.583 132.5C134.353 132.489 135.113 132.325 135.818 132.017C136.523 131.709 137.159 131.264 137.688 130.707L148.703 119.759L159.718 130.707C160.818 131.67 162.247 132.18 163.712 132.133C165.177 132.086 166.569 131.485 167.604 130.453C168.639 129.421 169.239 128.036 169.282 126.58C169.325 125.123 168.808 123.706 167.836 122.615L156.845 111.667Z",
    fill: "#D0004E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.577 187.369L223.877 173.098L225.729 174.867C227.527 176.583 228.603 178.98 228.721 181.531C228.839 184.082 227.99 186.578 226.359 188.469C224.729 190.361 222.451 191.494 220.027 191.618C217.603 191.742 215.231 190.848 213.434 189.132L211.581 187.364L211.577 187.369Z",
    fill: "#E1DCEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3374 51.8098C41.3217 50.6214 41.1726 49.4228 40.8745 48.216C39.8289 43.9809 35.164 41.262 30.199 40.6228C25.236 39.9835 20.0748 41.4382 18.0856 45.1222C16.9479 47.2284 16.7909 49.0438 17.2559 50.5743C17.7188 52.0966 18.8173 53.3587 20.3081 54.3422C24.4649 57.0815 31.7448 57.6409 35.066 56.4956C36.602 55.9649 38.1026 55.3257 39.564 54.5942C38.7284 59.3825 35.6152 63.9187 31.4603 68.0063C22.4307 76.8903 8.41844 83.6332 0.787503 86.1123C0.377512 86.2455 0.149938 86.7004 0.277447 87.1286C0.404957 87.5568 0.840442 87.7965 1.25043 87.6634C9.03242 85.135 23.3174 78.2487 32.5255 69.1885C37.2826 64.5088 40.6724 59.2411 41.2511 53.7029C52.005 47.7017 60.8365 36.8139 68.387 27.6513C68.6676 27.3132 68.6303 26.7989 68.3047 26.5059C67.979 26.215 67.4885 26.2518 67.208 26.592C59.9655 35.3797 51.5597 45.8331 41.3374 51.8098ZM39.774 52.6806C39.8328 51.3447 39.7072 49.9883 39.3679 48.6196C38.4635 44.9542 34.3067 42.7864 30.0087 42.2332C27.3742 41.8952 24.6651 42.1738 22.5406 43.1655C21.2047 43.7884 20.1041 44.6919 19.4411 45.9213C18.5701 47.5337 18.3818 48.9126 18.7388 50.0826C19.0958 51.2607 19.9826 52.2072 21.138 52.9674C24.926 55.465 31.5545 55.9957 34.5775 54.9528C36.3606 54.3381 38.0909 53.5718 39.774 52.6806Z",
    fill: "#000094"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 231.909,
    cy: 129.167,
    r: 5,
    fill: "#9DA4AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0624 163.662C43.9547 163.327 44.8937 162.883 45.6178 162.239C46.4778 161.474 46.8275 160.489 47.0624 159.452C47.364 158.12 47.4844 156.702 47.8501 155.368C47.9855 154.872 48.246 154.685 48.3578 154.602C48.6404 154.392 48.926 154.336 49.1947 154.357C49.5132 154.381 49.9506 154.508 50.2383 155.07C50.2793 155.15 50.3326 155.273 50.3685 155.44C50.3947 155.563 50.4116 155.948 50.4393 156.107C50.5085 156.498 50.5665 156.888 50.6209 157.281C50.8019 158.589 50.906 159.7 51.4778 160.901C52.2537 162.532 53.0311 163.53 54.0855 163.972C55.105 164.399 56.3239 164.319 57.8814 163.984C58.0296 163.946 58.1762 163.914 58.3214 163.887C59.008 163.761 59.6645 164.235 59.7993 164.955C59.9342 165.675 59.4978 166.376 58.8173 166.534C58.6752 166.567 58.5352 166.598 58.3968 166.627C56.2922 167.175 53.8557 169.132 52.4398 170.845C52.0034 171.374 51.3645 172.851 50.7127 173.793C50.2316 174.488 49.6911 174.946 49.2373 175.108C48.9332 175.217 48.6768 175.201 48.465 175.146C48.1573 175.066 47.9019 174.89 47.706 174.611C47.5993 174.459 47.5003 174.254 47.4532 173.993C47.4306 173.867 47.428 173.548 47.4286 173.403C47.2957 172.922 47.1332 172.453 47.0147 171.967C46.7321 170.81 46.1778 170.077 45.5193 169.109C44.9034 168.202 44.2419 167.633 43.2722 167.179C43.146 167.146 42.1281 166.884 41.7686 166.733C41.2434 166.513 40.9932 166.143 40.9024 165.944C40.748 165.606 40.7322 165.311 40.7629 165.065C40.8086 164.702 40.9634 164.391 41.2383 164.14C41.4086 163.984 41.6629 163.832 42.0034 163.758C42.2665 163.7 42.9644 163.667 43.0624 163.662ZM49.0342 161.775C49.0814 161.886 49.1316 161.997 49.185 162.109C50.3214 164.498 51.5921 165.832 53.1368 166.479L53.1886 166.5C52.1552 167.307 51.2198 168.21 50.505 169.075C50.2106 169.431 49.8209 170.171 49.3998 170.93C49.0173 169.621 48.3916 168.696 47.605 167.538C47.0039 166.655 46.3742 165.99 45.6004 165.448C46.2009 165.124 46.7737 164.744 47.2727 164.3C48.1034 163.561 48.6527 162.705 49.0342 161.775Z",
    fill: "#9DA4AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_146_2534",
    x: 38.5754,
    y: 18.7974,
    width: 163.781,
    height: 189.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_146_2534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_146_2534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_146_2534",
    x: 173.242,
    y: 5.52002,
    width: 84.5159,
    height: 59.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_146_2534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_146_2534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_146_2534",
    x: 95.5754,
    y: 58.6665,
    width: 106.833,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_146_2534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_146_2534",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.cd44d4537f672ed42abe25d938d1fcb8.svg";
export { ForwardRef as ReactComponent };